import React from "react"
import { Link } from "gatsby"
import * as styles from "./footerstyles.module.scss"
import { SocialLinks } from "./SocialLinks"
import translate from "../../helpers/Translate"
import settings from "../../helpers/settings"

export const MobileFooter = ({ menu, menu2, menu3, logo, alt }) => {

    return(
        <footer className={`${styles.siteFooter} ${styles.mobileFooter}`}>
			
				<div className={`wrapper ${styles.mobileFooterWrapper} `}>

                    <img src={logo} className={styles.footerLogo} alt={alt}/>

                    <p>
						{translate('Bedbible.com is your one and only source on the journey to better sex. We’re 100% reader-supported, so when you buy products through links on our site, we may earn a commission at no extra cost to you.')}
					</p>

					<div className={`${styles.followUs} ${styles.mobileFollowUs}`} style={{ marginTop : '20px' }}>
						<span><strong>{translate('Follow us:')}</strong></span>
						<div className={`${styles.socialLinks} ${styles.mobileSocialLinks}`}>
							<SocialLinks/>
						</div>
					</div> 

                    <ul className={`${styles.footerMenu} ${styles.footerMobileMenu}`}>
						<span className={styles.column__name}>{translate('Information')}</span>
						{menu.map((item, id) =>
							<li className={styles.footerMenu__item} key={`m1-${id}`}>
								<Link to={item.url} className={styles.footerMenu__link}>
									{item.label}
								</Link>
							</li>
						)}
						{menu3.length > 0 &&
						<span className={styles.column__name}>{translate('Resourses')}</span>}
						{menu3.map((item, id) =>
							<li className={styles.footerMenu__item} key={`m2-${id}`}>
								<Link to={item.url} className={styles.footerMenu__link}>
									{item.label}
								</Link>
							</li>
						)}
						<span className={styles.column__name}>{translate('Reviews')}</span>
						{menu2.map((item, id) =>
							<li className={styles.footerMenu__item} key={`m2-${id}`}>
								<Link to={item.url} className={styles.footerMenu__link}>
									{item.label}
								</Link>
							</li>
						)}
					</ul>

                    <p className={styles.footerCopyright} style={{ marginTop : '20px' }}>
						{settings[ process.env.GATSBY_SITE_LANG ].copyrights}
					</p>         
					
				</div>
			</footer>
    )
}